import { BodyPartFilterModel, bodyPartUtil } from '../component/workout-filter/body-part/body-part-util'
import { BodyPart } from '../dao/core-dao'
import { coreService } from '../service/core-service'
import { UseQueryResult, useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { queryKeys } from 'src/util/query-keys'

type BodyPartsData = {
  bodyParts: BodyPartFilterModel[]
  rootDepth: Record<string, number>
}

export const useBodyPartsQuery = (): UseQueryResult<BodyPart[], Error> => {
  return useQuery<BodyPart[], Error>(queryKeys.bodyParts(), () => coreService.getBodyParts())
}

export const useBodyParts = (): BodyPartsData => {
  const { data: rawBodyParts } = useBodyPartsQuery()

  return useMemo(() => {
    if (!rawBodyParts) return { bodyParts: [] as BodyPartFilterModel[], rootDepth: {} as Record<string, number> }

    const bodyParts = bodyPartUtil.toGraph(rawBodyParts)

    const rootDepth = bodyParts.reduce((acc, root) => {
      acc[root.id] = bodyPartUtil.getFiltersDepth(root)
      return acc
    }, {} as Record<string, number>)

    return { bodyParts, rootDepth }
  }, [rawBodyParts])
}
